import React from "react";
import ListingPage from "@/pages/ListingPage";

export default function SalesPage() {
  return (
    <ListingPage
      listingType="sales"
      title="Investment-grade student housing for sale."
      subtitle="Buildings, portfolios and development sites — sourced with rigour, priced on fundamentals."
      heroImg="https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=1920&auto=format&fit=crop&q=80"
    />
  );
}
